import { createSelector } from '@reduxjs/toolkit';
import { BookingTime, TimeslotState } from './types';
import { checkUtcInTime, formatTime } from 'shared/lib/time';

const selectBase = createSelector(
	(state: RootState) => state,
	(state: RootState) => state.timeslotsReducer,
);

export const selectTimeslotsMap = createSelector(
	selectBase,
	(state: TimeslotState) => state.timeslotsMap,
);

export const selectTimeslots = createSelector(
	selectBase,
	(state: TimeslotState) => state.timeslots,
);

export const selectTimeslotDate = createSelector(
	selectBase,
	(state: TimeslotState) => {
		if (state.timeslots.length) {
			return state.timeslots[0].dt_start;
		}
		return '';
	},
);

export const selectTime = createSelector(selectBase, (state: TimeslotState) => {
	if (state.timeslots.length) {
		const formattedTime = formatTime({ time: state.timeslots[0].dt_start });
		if (formattedTime) {
			return formattedTime.time;
		}
		return '';
	}
});

export const selectLastTimeUse = createSelector(
	selectBase,
	(state: TimeslotState) => state.lastTimeUsed,
);

export const selectTimeslotsLoader = createSelector(
	selectBase,
	(state: TimeslotState) => state.loading,
);

export const selectSelectedTimeslot = createSelector(
	selectBase,
	(state: TimeslotState) => state.selectedTimeslot,
);

export const selectErrorTimeslots = createSelector(
	selectBase,
	(state: TimeslotState) => state.error,
);

export const selectBookingTimes = createSelector(
	selectBase,
	(state: TimeslotState) => state.bookingTimes,
);

export const selectAllBookingTimes = createSelector(
	selectBase,
	(state: TimeslotState) => state.allBookingTimes,
);

export const selectActiveBookingTime = createSelector(
	selectBase,
	(state: TimeslotState) => {
		const bookingTime = state.bookingTimes.find(
			(bookingTime: BookingTime) =>
				bookingTime.isExact && bookingTime.hasSeats,
		);
		if (!bookingTime) {
			return null;
		}
		return bookingTime;
	},
);

export const selectDisableBookingTime = createSelector(
	selectBase,
	(state: TimeslotState) => {
		const bookingTime = state.bookingTimes.find(
			(bookingTime: BookingTime) =>
				bookingTime.isExact && !bookingTime.hasSeats,
		);
		if (!bookingTime) {
			return null;
		}
		return bookingTime;
	},
);

export const selectTimesOptions = createSelector(
	selectBase,
	(state: TimeslotState) => state.timesOptions,
);

export const selectBookingSlotsLoader = createSelector(
	selectBase,
	(state: TimeslotState) => state.loadingBookingSlots,
);

export const selectBookingSlotsError = createSelector(
	selectBase,
	(state: TimeslotState) => state.errorBookingSlots,
);

export const selectIsTimeslotUtc = createSelector(
	selectBase,
	(state: TimeslotState) => {
		if (state.timeslots.length) {
			return checkUtcInTime(state.timeslots[0].dt_start);
		}
		return false;
	},
);
